import { Component, OnInit } from '@angular/core';
import { MatDialog } from '@angular/material';
import { NewActivityComponent } from '../partials/new-activity/new-activity.component';
import { AuthenticationService } from '../../services/authentication.service';
import { DBService } from '../../services/db.service';
import { Company } from '../../model/company';
import { User } from '../../model/user';
import { Activity, ActivityStatus } from '../../model/activity';
import { ConfirmDeleteComponent } from '../partials/confirm-delete/confirm-delete.component';

declare var Materialize: any;

@Component({
  selector: 'app-activities',
  templateUrl: './activities.component.html',
  styleUrls: ['./activities.component.css'],
  providers: [DBService, AuthenticationService]
})
export class ActivitiesComponent implements OnInit {

  loading: boolean;

  companies: Company[];

  users: User[];

  allActivities: Activity[];
  activities: Activity[];

  searchText: string;
  statusFilter: number;
  companyFilter: string;
  categoryFilter: number;

  userCompanyUID: string;

  constructor(public dialog: MatDialog, private dbService: DBService, private authService: AuthenticationService) {
    this.loading = true;
    this.statusFilter = 0;
    this.companyFilter = '0';
    this.searchText = '';

    if (!this.authService.isAdmin()) {
      this.userCompanyUID = this.authService.getUserCompany();
      this.companyFilter = this.userCompanyUID;
    }

    this.loadCompanies();
    this.loadUsers();
  }

   private loadCompanies() {
    this.dbService.listWithUIDs<Company>('companies')
      .then(companies => {
        if (this.userCompanyUID) {
          this.companies = companies.filter(c => c.uid === this.userCompanyUID);
        } else {
          this.companies = companies;
        }
      });
  }

  private loadUsers() {
    this.dbService.listWithUIDs<User>('users')
      .then(users => {
        this.users = users;

        this.loadActivities();
      });
  }

  private loadActivities() {
    this.dbService.listWithUIDs<Activity>('activities')
      .then(activities => {
        this.allActivities = activities.sort((a1, a2) => a2.creationDate - a1.creationDate);
        this.updateActivities();
        this.loading = false;
      });
  }

  onSearchChange(searchValue: string ) {
    this.searchText = searchValue.toLowerCase();

    this.filterData();
  }

  filterData() {
    let displayActivities = this.allActivities;

    if (this.statusFilter != 0) {
      displayActivities = displayActivities.filter(a => a.status == this.statusFilter);
    }

    if (this.categoryFilter != 0) {
      displayActivities = displayActivities.filter(a => a.category == this.categoryFilter);
    }

    if (this.companyFilter != '0') {
      displayActivities = displayActivities.filter(a => a.companyUID == this.companyFilter);
    }

    if (this.searchText.trim().length > 1) {
      displayActivities = displayActivities
      .filter(item => item.description.toLowerCase().includes(this.searchText) ||
                      item.expirationDateString.toLowerCase().includes(this.searchText) ||
                      item['userText'].toLowerCase().includes(this.searchText) ||
                      item['companyText'].toLowerCase().includes(this.searchText) ||
                      item['statusText'].toLowerCase().includes(this.searchText));
    }

    this.activities = displayActivities;

    this.loading = false;
  }

  private updateActivities() {
    const now = Date.now();

    this.allActivities.forEach(activity => {
      if (activity.status !== ActivityStatus.DONE && activity.expirationDate < now) {
        activity.status = ActivityStatus.EXPIRED;
        activity['statusText'] = 'Atrasada';
      } else if (activity.status === ActivityStatus.TODO) {
        activity['statusText'] = 'A realizar';
      } else if (activity.status === ActivityStatus.EXPIRED) {
        activity['statusText'] = 'Atrasada';
      } else {
        activity['statusText'] = 'Finalizada';
      }

      activity['companyText'] = '';

      const filteredCompanies = this.companies.filter(a => a.uid === activity.companyUID);
      if (filteredCompanies.length > 0) {
        activity['companyText'] = filteredCompanies[0].name;
      } else {
        this.dbService.remove('activities', activity.uid);
      }

      activity['userText'] = this.users.filter(u => u.uid === activity.sentUserUID)[0].name;
    });

    this.allActivities = this.allActivities.filter(b => b['companyText'] != '');

    this.loading = false;
  }

  ngOnInit() {
  }

  goToNew() {
    const dialogRef = this.dialog.open(NewActivityComponent, {
      height: 'auto',
      width: '875px',
      data: {  }
    });

    dialogRef.afterClosed().subscribe(result => {
      if (result) { this.confirmNew(result); }
    });
  }

  goToEdit(activity: Activity) {
    const dialogRef = this.dialog.open(NewActivityComponent, {
      height: 'auto',
      width: '875px',
      data: { uid: activity.uid  }
    });

    dialogRef.afterClosed().subscribe(result => {
      if (result) { this.confirmNew(result); }
    });
  }

  confirmNew(result: any) {
    this.resetData();
  }

  private resetData() {
    this.loading = true;
    this.activities = [];
    this.loadActivities();
    
    this.statusFilter = 0;
    this.categoryFilter = 0;
    this.companyFilter = this.userCompanyUID;    
    this.filterData();
  }

  openFinishModal(activity: Activity) {
    const dialogRef = this.dialog.open(ConfirmDeleteComponent, {
      height: 'auto',
      width: '600px',
      data: { name: 'Atividade', action: 'Tem certeza que deseja marcar a atividade como finalizada ' }
    });

    dialogRef.afterClosed().subscribe(result => {
      if (result) { this.confirmFinish(activity.uid); }
    });
  }

  private confirmFinish(uid: string) {
    this.loading = true;
    this.dbService.update(`/activities/${uid}`, { status: ActivityStatus.DONE, finishDate: new Date().getTime() } )
      .then(() => {
        Materialize.toast('Atividade finalizada com sucesso', 2000);
        this.resetData();
      })
      .catch(error => console.log(error));
  }

  openDeleteModal(activity: Activity) {
    const dialogRef = this.dialog.open(ConfirmDeleteComponent, {
      height: 'auto',
      width: '600px',
      data: { name: 'Atividade' }
    });

    dialogRef.afterClosed().subscribe(result => {
      if (result) { this.confirmDelete(activity.uid); }
    });
  }

  private confirmDelete(uid: string) {
    this.loading = true;
    this.dbService.remove('/activities', uid)
      .then(() => {
        Materialize.toast('Atividade removida com sucesso', 2000);
        this.resetData();
      })
      .catch(error => console.log(error));
  }
}



// WEBPACK FOOTER //
// ./src/app/pages/activities/activities.component.ts